import { create } from 'zustand';
import { getState, useState } from '@/framework';
import type { IExportState, StateType } from '@/version-types';
import type { SmartGuideBlock, SmartGuideLine, SmartGuidesState } from '../types';

interface SmartGuidesStore {
    /** 供视图读取的不可变提示快照。 */
    snapshot: SmartGuidesState;
    /** 替换智能参考线。 */
    setLines: (lines: readonly SmartGuideLine[]) => void;
    /** 替换等间距提示区域。 */
    setBlocks: (blocks: readonly SmartGuideBlock[]) => void;
    /** 同时清空参考线和等间距提示。 */
    clear: () => void;
}

const createState = () =>
    create<SmartGuidesStore>((set) => ({
        snapshot: {
            lines: [],
            blocks: [],
        },
        setLines(lines) {
            set(({ snapshot }) => ({
                snapshot: {
                    ...snapshot,
                    lines: [...lines],
                },
            }));
        },
        setBlocks(blocks) {
            set(({ snapshot }) => ({
                snapshot: {
                    ...snapshot,
                    blocks: [...blocks],
                },
            }));
        },
        clear() {
            set((state) => {
                if (!state.snapshot.lines.length && !state.snapshot.blocks.length) return state;
                return {
                    snapshot: {
                        lines: [],
                        blocks: [],
                    },
                };
            });
        },
    }));

const name = 'smart-guides-state';
type ModuleType = StateType<SmartGuidesStore, typeof name>;

/** 插件视图内部使用的 Zustand store */
export const useSmartGuidesState = () => useState<ModuleType>()[name];

/** 插件内部按编辑器 identity 获取 Zustand store */
export const getSmartGuidesStore = (identity: string) => getState<ModuleType>(identity)[name];

const exportState: IExportState = {
    name,
    createState,
};

export default exportState;
